"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateRoomSchema = exports.createRoomSchema = exports.roomShape = exports.roomTypeEnum = void 0;
const zod_1 = require("zod");
// Hospital Infrastructure — Room Master. `roomCode` is server-generated
// (ward.code + roomNumber) and deliberately not part of the create/
// update input shape.
exports.roomTypeEnum = zod_1.z.enum([
    'GENERAL',
    'PRIVATE',
    'SEMI_PRIVATE',
    'DELUXE',
    'SUITE',
    'ICU',
    'NICU',
    'PICU',
    'SICU',
    'LABOUR',
    'OT',
    'PROCEDURE',
]);
exports.roomShape = {
    wardId: zod_1.z.string().uuid(),
    nursingStationId: zod_1.z.string().uuid().nullable().optional(),
    roomNumber: zod_1.z.string().min(1).max(30),
    name: zod_1.z.string().max(150).nullable().optional(),
    type: exports.roomTypeEnum,
    category: zod_1.z.string().max(100).nullable().optional(),
    building: zod_1.z.string().max(150).nullable().optional(),
    floor: zod_1.z.string().max(50).nullable().optional(),
    plannedCapacity: zod_1.z.number().int().min(1).optional(),
    isAirConditioned: zod_1.z.boolean().optional(),
    isIsolationRoom: zod_1.z.boolean().optional(),
    hasAttachedBathroom: zod_1.z.boolean().optional(),
    hasAttendantBed: zod_1.z.boolean().optional(),
    hasTv: zod_1.z.boolean().optional(),
    hasTelephone: zod_1.z.boolean().optional(),
    hasWifi: zod_1.z.boolean().optional(),
    isWheelchairAccessible: zod_1.z.boolean().optional(),
    displayOrder: zod_1.z.number().int().min(0).optional(),
    description: zod_1.z.string().nullable().optional(),
    isActive: zod_1.z.boolean().optional(),
};
exports.createRoomSchema = zod_1.z.object(exports.roomShape);
exports.updateRoomSchema = exports.createRoomSchema.partial();
//# sourceMappingURL=room.schema.js.map